import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { Types } from "Types";
import { Selectors as DossierLocationSelector } from "../../../redux/DossierLocation";
import {
  ActionCreators,
  Selectors as SituationPersonnelleSelectors,
} from "../../../redux/SituationPersonnelle";
import {
  useGetCommunes,
  useGetListTypeVoie,
} from "../../../hooks/Localisation";
import {
  usePostSituationPersonnellePrincipal,
  usePutSituationPersonnellePrincipal,
} from "../../../hooks/SituationPersonnelle";
import {
  Commune,
  DossierParticulier,
  SituationPersonnelleDossierParticulier,
} from "../../../services/Api/swagger";
import {
  buildOneSituationPersoApi,
  buildSituationFormOnModification,
  buildSituationPersoForm,
  SituationPersonnelleForm,
} from "./helpers";

export const useSituationPersonnelle = () => {
  const {
    data: typesVoie,
    isFetching: typeVoieFetching,
    error: typeVoieError,
    refetch: loadTypesVoie,
  } = useGetListTypeVoie();

  const { data: communes, mutate: getCommunes } = useGetCommunes();

  const chargerCommunes = (commune: Commune) => {
    getCommunes(commune);
  };

  const dossierLocation = useSelector((state: Types.RootState) =>
    DossierLocationSelector.getDossierLocation(state)
  );
  // const modifSituationPersoData = useSelector((state: Types.RootState) =>
  //   DossierLocationSelector.getSituationPersoData(state)
  // );
  const situationPersonnelle = useSelector((state: Types.RootState) =>
    SituationPersonnelleSelectors.getSituationPersonnelle(state)
  );
  const selectedPerson = useSelector((state: Types.RootState) =>
    DossierLocationSelector.getSelectedPerson(state)
  );
  const dossierLocationRef = useSelector((state: Types.RootState) =>
    DossierLocationSelector.getSelectedDossier(state)
  );

  const [initialValues, setInitialValues] =
    useState<SituationPersonnelleForm>();

  useEffect(() => {
    let modifSituationPersoPrincipal =
      dossierLocation?.dossiersParticuliers?.find(
        (dos) => dos.reference === selectedPerson
      );

    let modifSituationConjoint = undefined;
    if (
      modifSituationPersoPrincipal?.compositionLocation === "COUPLE" &&
      modifSituationPersoPrincipal &&
      modifSituationPersoPrincipal.typeCompte !== "GARANT" &&
      dossierLocation?.dossiersParticuliers
    ) {
      modifSituationPersoPrincipal = dossierLocation.dossiersParticuliers[0];
      modifSituationConjoint = dossierLocation.dossiersParticuliers?.find(
        (dos) => !dos.principal && dos.typeCompte === "LOCATAIRE"
      );
    }

    const situationPersoData =
      modifSituationPersoPrincipal &&
      buildSituationFormOnModification(
        modifSituationPersoPrincipal,
        modifSituationConjoint
      );
    setInitialValues(
      (situationPersonnelle && situationPersonnelle.situationPrincipale.nom) ||
        (!situationPersoData && situationPersonnelle)
        ? buildSituationPersoForm(situationPersonnelle)
        : situationPersoData
    );
  }, []);

  const {
    mutate: postSituationPersoUnitaire,
    error: postError,
    isLoading: postLoading,
    reset: resetPost,
    isSuccess: isSuccessPost,
    data: dataPrincipal,
  } = usePostSituationPersonnellePrincipal();

  const {
    mutate: putSituationPersoUnitaire,
    error: putError,
    isLoading: putLoading,
    reset: resetPut,
    isSuccess: isSuccessPut,
    variables: dataPrincipalPut,
  } = usePutSituationPersonnellePrincipal();

  const {
    mutate: postSituationPersoConjoint,
    error: postErrorConjoint,
    isLoading: postLoadingConjoint,
    reset: resetPostConjoint,
    isSuccess: isSuccessPostConjoint,
    data: dataSecondaire,
  } = usePostSituationPersonnellePrincipal();

  const {
    mutate: putSituationPersoConjoint,
    error: putErrorConjoint,
    isLoading: putLoadingConjoint,
    reset: resetPutConjoint,
    isSuccess: isSuccessPutConjoint,
    variables: dataSecondairePut,
  } = usePutSituationPersonnellePrincipal();

  const navigate = useNavigate();
  const [hasConjoint, setHasConjoint] =
    useState<
      | {
          dossierLocationRef?: string;
          situationPersonnelle: SituationPersonnelleDossierParticulier;
          reference?: string;
        }
      | undefined
    >(undefined);
  const handleSubmit = (data: Types.SituationPersonnelleData) => {
    const { situationPrincipale, situationConjoint } = data;

    if (situationConjoint) {
      setHasConjoint({
        dossierLocationRef: dossierLocationRef,
        situationPersonnelle: situationConjoint,
        reference: situationConjoint?.reference,
      });
    }
    // CREATE OR UPDATE PRINCIPAL
    if (situationPrincipale.reference) {
      putSituationPersoUnitaire({
        dossierLocationRef,
        principal: situationPrincipale,
        reference: situationPrincipale.reference,
        prefixe: "principal",
      });
    } else {
      postSituationPersoUnitaire({
        dossierLocationRef,
        principal: situationPrincipale,
        prefixe: "principal",
      });
    }
  };

  const dispatch = useDispatch();
  useEffect(() => {
    if (isSuccessPost || isSuccessPut) {
      const data = dataPrincipal || dataPrincipalPut?.principal;
      // const situationPersonnelleType = data && buildOneSituationPersoApi(data);
      data &&
        dispatch(
          ActionCreators.updateSituationPersonnellePrincipal({
            situation: data as DossierParticulier,
          })
        );
      if (hasConjoint) {
        if (hasConjoint.reference) {
          putSituationPersoConjoint({
            dossierLocationRef,
            principal: hasConjoint.situationPersonnelle,
            reference: hasConjoint.reference,
            prefixe: "secondaire",
          });
        } else {
          postSituationPersoConjoint({
            dossierLocationRef,
            principal: hasConjoint.situationPersonnelle,
            prefixe: "secondaire",
          });
        }
      } else {
        navigate("/dossier-location/situation-professionnelle");
      }
    }
  }, [isSuccessPost, isSuccessPut]);

  useEffect(() => {
    if (isSuccessPostConjoint || isSuccessPutConjoint) {
      const data = dataSecondaire || dataSecondairePut?.principal;
      // const situationPersonnelleType: DossierParticulier | undefined =
      //   data && buildOneSituationPersoApi(data);
      data &&
        dispatch(
          ActionCreators.updateSituationPersonnelleConjoint({
            situation: data as DossierParticulier,
          })
        );
      navigate("/dossier-location/situation-professionnelle");
    }
  }, [isSuccessPostConjoint, isSuccessPutConjoint]);
  return {
    typesVoie,
    typeVoieFetching,
    typeVoieError,
    loadTypesVoie,
    chargerCommunes,
    communes,
    dossierLocation,
    dossierLocationRef,
    postError,
    postLoading,
    putError,
    putLoading,
    handleSubmit,
    resetPost,
    resetPut,
    selectedPerson,
    // postErrorSecondaire,
    // postLoadingSecondaire,
    // resetPostSecondaire,
    // putErrorSecondaire,
    // putLoadingSecondaire,
    // resetPutSecondaire,
    initialValues,
  };
};
